import Component_GizmoManager_14f1d9be4a9b3b6e13de56f00a6a74fd from "../../../../content/examples/basic/gizmo-manager/GizmoManager";
import Devtool_GizmoManager_14f1d9be4a9b3b6e13de56f00a6a74fd from "!!@devtool/loader!../../../../content/examples/basic/gizmo-manager/GizmoManager";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_GizmoManager_14f1d9be4a9b3b6e13de56f00a6a74fd,
  Devtool_GizmoManager_14f1d9be4a9b3b6e13de56f00a6a74fd,
  DevTool,
  React
};